import React from "react"
import {Navigate} from "react-router"

import {Loading} from "../../components/Loading"
import {useUserSettingsQuery} from "../../queries/user.ts"
import {RouterError} from "../../RouterError"
import {AUserTypes} from "../../services/types.generated"
import {useNumParam} from "../../utils/hooks"

export const MySalespersonGate: React.FC<{
  Component: React.ComponentType
  redirectToCurrentIfUndef?: boolean // do a relative path redirect to the current user if salespersonId is undef
}> = ({Component, redirectToCurrentIfUndef}) => {
  const {status, data} = useUserSettingsQuery()
  const salespersonId = useNumParam("salespersonId", true)

  if (redirectToCurrentIfUndef && salespersonId === undefined && data?.user.id) {
    return <Navigate to={String(data.user.id)} replace /> // relative redirect to the current user
  }

  const isUserMe = data?.user.type === AUserTypes.SalesPerson && data?.user.id === salespersonId

  if (status === "pending") {
    return <Loading size={"xl"} />
  }
  if (status === "error") {
    return <Navigate to={"/log-in"} />
  }

  if (!data || (!isUserMe && data.user.type !== AUserTypes.Admin)) {
    return <RouterError force404 />
  }

  return <Component />
}
